<template>
    <div class="showImg" @click="$emit('click')">
        <img v-if="!isError"
            style="max-height: 50px;max-width: 100%;"
            :src="url"
            @error="resourcesError"
        />
        <img v-else style="height: 50px;" class="error-img" src="~@/assets/img/error.png"/>
    </div>
</template>
<script>
export default {
    name: 'showImg',
    props: {
        url: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            isError: false
        }
    },
    methods: {
        resourcesError() {
            this.isError = true;
        }
    },
}
</script>